import React from 'react';
import {
  Box,
  Typography,
  Avatar,
  Rating,
  Divider,
  Button,
  styled,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Paper,
} from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom'; // Assuming you are using React Router

const HealthDetailWeb = () => {
  const doctor = {
    name: 'Ember Wynn',
    specialty: 'Pediatric Neurology',
    profession: 'Pediatrician',
    hospital: 'National Hospital ABUJA',
    rating: 5.0,
    reviews: 20,
    image: 'https://via.placeholder.com/300/123456', // Larger placeholder image for web
    about:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lacus, nulla a accumsan at morbi bibendum tortor id a. Nullam amet, ultricies orci ultrices odio condimentum. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    workingHours: 'Monday - Friday 9:00AM - 2:00 PM',
    lastLogin: 'Tuesday, April 8, 2025',
    email: 'Emberwyn45@NHAhospital.com',
    phone: '+23481-785-253',
  };

  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate('/doctors'); // Go back to the previous page

  };

  return (
    <Box sx={{ p: 4 }}>
      <Button startIcon={<ArrowBackIcon />} onClick={handleGoBack} sx={{ mb: 3 }}>
        Back to Doctors
      </Button>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Grid container spacing={4} alignItems="center">
          <Grid item md={4}>
            <Avatar align="center" src={doctor.profilePicture} alt={doctor.name} sx={{ width: 140, height: 140, mb: 2, ml: 8 }} />
            <Typography variant="h5" fontWeight="bold" align="center" sx={{ mb: 1 }}>
              {doctor.name}
            </Typography>
            <Typography variant="subtitle1" color="text.secondary" align="center" sx={{ mb: 0.5 }}>
              {doctor.specialty}
            </Typography>
            <Typography variant="subtitle1" color="text.secondary" align="center">
              {doctor.profession} | {doctor.hospital}
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 1 }}>
              <Rating name="doctor-rating-web" value={doctor.rating} readOnly />
              <Typography variant="body2" color="text.secondary" sx={{ ml: 1 }}>
                ({doctor.reviews} reviews)
              </Typography>
            </Box>
            <Button onClick={()=>navigate('/book-appointment')} variant="contained" color="success" fullWidth sx={{ mt: 3 }}>
              Book Appointment
            </Button>
          </Grid>
          <Grid item md={8}>
            <Typography variant="h6" sx={{ mb: 1 }}>
              About Dr. {doctor.name.split(' ')[1]}
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              {doctor.about}
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Grid container spacing={2}>
              <Grid item md={6}>
                <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 0.5 }}>
                  Working Hours
                </Typography>
                <Typography variant="body2">{doctor.workingHours}</Typography>
              </Grid>
              <Grid item md={6}>
                <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 0.5 }}>
                  Last Login
                </Typography>
                <Typography variant="body2">{doctor.lastLogin}</Typography>
              </Grid>
            </Grid>
            <Divider sx={{ my: 2 }} />
            <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1 }}>
              Contact Details
            </Typography>
            <List>
              <ListItem disablePadding>
                <ListItemAvatar>
                  <Avatar sx={{ bgcolor: 'primary.light' }}>
                    <EmailIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText primary={doctor.email} />
              </ListItem>
              <ListItem disablePadding>
                <ListItemAvatar>
                  <Avatar sx={{ bgcolor: 'success.light' }}>
                    <PhoneIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText primary={doctor.phone} />
              </ListItem>
            </List>
          </Grid>
        </Grid>
        <Typography variant="caption" color="text.secondary" align="center" sx={{ mt: 3, display: 'block' }}>
          Rate your experience with Doctor {doctor.name.split(' ')[1]}
        </Typography>
        {/* Implement rating component here if needed */}
      </Paper>
    </Box>
  );
};

export default HealthDetailWeb;
